import { useEffect } from 'react';

/**
 * A custom hook to request a screen wake lock preventing the screen from dimming/locking.
 * It also re-requests the wake lock when the document becomes visible again.
 */
export const useWakeLock = () => {
	useEffect(() => {
		let wakeLock: WakeLockSentinel | null = null;

		const requestWakeLock = async () => {
			try {
				if ('wakeLock' in navigator) {
					wakeLock = await navigator.wakeLock.request('screen');
					console.log('Screen Wake Lock is active');
				}
			} catch (err) {
				const error = err as Error;
				console.error(`Wake Lock error: ${error.name}, ${error.message}`);
			}
		};

		const handleVisibilityChange = () => {
			if (wakeLock !== null && document.visibilityState === 'visible') {
				requestWakeLock();
			}
		};

		// Initially request the wake lock
		requestWakeLock();

		// Listen for visibility changes to re-request the wake lock if the tab is switched
		document.addEventListener('visibilitychange', handleVisibilityChange);

		return () => {
			document.removeEventListener('visibilitychange', handleVisibilityChange);
			if (wakeLock) {
				wakeLock.release().then(() => {
					wakeLock = null;
				});
			}
		};
	}, []);
};
